<mat-card class="card-style px-6 py-6 pt-0 h-full">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Cancelar/Reprovar Proposta</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <div class="mt-5 container mx-auto">
    <mat-card class="card-style px-4 py-6">
      <div class="flex justify-between gap-2 mt-4">
        <div><strong>TG:</strong> {{ item.codigoTg }}</div>
        <div><strong>Evento:</strong> {{ item.nomeEvento }}</div>
        <div><strong>Emissão:</strong> {{ item.dataCriacao }}</div>
        <div>
          <strong>Período:</strong> {{ item.dataInicio }} - {{ item.dataFim }}
        </div>
      </div>
      <div class="flex justify-between gap-2 mt-4">
        <div><strong>Cliente:</strong> {{ item.nomeCliente }}</div>
        <div>
          @if (item.nomeSubCliente) {
            <br /><strong>Subcliente:</strong> {{ item.nomeSubCliente ?? '-' }}
          }
        </div>
        <div><strong>Valor</strong> {{ item.valorTotalFormatado }}</div>
      </div>
      <div class="flex justify-between gap-2 mt-4">
        <div><strong>Solicitante:</strong> {{ item.solicitante }}</div>
        <div><strong>Email:</strong> {{ item.solicitanteEmail }}</div>
        <div>
          <strong>Telefone</strong> {{ item.solicitanteTelefone | telefone }}
        </div>
      </div>
    </mat-card>
    @if (!loading) {
      <div
        [formGroup]="form"
        class="flex justify-between gap-4 py-2 px-6 mt-4 items-center"
      >
        <mat-form-field
          class="input-tg w-3/12 px-2 no-message-new"
          appearance="outline"
        >
          <mat-label>Cancelado/Reprovado</mat-label>
          <mat-select
            formControlName="cancelSelected"
            (selectionChange)="onSelectionCancel($event)"
          >
            @for (item of listCancel; track item) {
              <mat-option [value]="item.value">
                {{ item.description }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field
          class="input-tg w-9/12 px-2 no-message-new"
          appearance="outline"
        >
          <mat-label>Motivo</mat-label>
          <mat-select formControlName="reasonSelected">
            @for (item of listReason; track item) {
              <mat-option [value]="item.id">
                {{ item.descricao }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="flex justify-end gap-4 py-2 px-6 mt-6 items-center">
        <button
          mat-flat-button
          class="btn-tg w-2/5"
          [disabled]="form.invalid || loading"
          (click)="cancelProposalClient()"
        >
          @if (loading) {
            <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
          } @else {
            Cancelar Proposta
          }
        </button>
        <!--  <button mat-flat-button class="btn-tg w-full mt-6" [disabled]="!checkForm()" (click)="sendLogin()">entrar</button>-->
      </div>
    } @else {
      <mat-divider></mat-divider>
      <div class="flex flex-col items-center gap-4">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        <!--        <h3>-->
        <!--          <br />-->
        <!--          Arquivo sendo gerado!-->
        <!--        </h3>-->
      </div>
    }
  </div>
</mat-card>
